import authService from '@/services/AuthService'
import * as types from '../mutation-types'

export const authStore = {
  state: () => ({
    auths: [],
    authsCache: {
      expiresAt: null,
      ttl: 60000
    }
  }),

  mutations: {
    [types.AUTH_GET_USER_AUTHORITIES] (state, auths) {
      state.auths = auths
      state.authsCache.expiresAt = Date.now() + state.authsCache.ttl
    }
  },

  getters: {
    hasAuths (state) {
      return state.auths.length > 0
    },
    authsCache (state) {
      return state.authsCache
    },
    auths (state) {
      return state.auths
    }
  },

  actions: {
    async [types.AUTH_GET_USER_AUTHORITIES] (context) {
      const { expiresAt } = context.state.authsCache
      const isAuthsCacheValid = !!expiresAt && Date.now() < expiresAt

      if (!isAuthsCacheValid) {
        const response = await authService.getCurrentAuths()
        context.commit(types.AUTH_GET_USER_AUTHORITIES, response.data)
      }
    }
  }
}
